import { useRouterState } from "@tanstack/react-router"
import {
  useCallback,
  useEffect,
} from "react"
import { useSegment } from "./useSegment"

export function SegmentPageTracker() {
  const analyticsRef = useSegment()

  const currentPath = useRouterState({
    select: (s) => s.resolvedLocation.pathname,
  })

  const trackPageView = useCallback(
    (path: string) => {
      void analyticsRef.current.page({
        path,
        url: window.location.href,
        title: document.title,
      })
    },
    [analyticsRef],
  )

  useEffect(
    () => {
      trackPageView(currentPath)
    },
    [
      currentPath,
      trackPageView,
    ],
  )

  return null
}
